import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextField, Button, Card, CardHeader } from '@material-ui/core';
import CheckCircleTwoTone from '@material-ui/icons/CheckCircleTwoTone';
import { get } from 'lodash';

import { auth, emailSignin } from '../state/user';
import { colors } from '../lib/styles';


const styles = {
  container: {
    backgroundAttachment: 'scroll',
    backgroundRepeat: 'repeat',
    height: '100%',
    minHeight: '900px',
    padding: '10px',
  },
  loginBox: {
    margin: '0 auto 100px',
    textAlign: 'center',
    width: '500px',
  },
  errorText: {
    color: colors.secondaryAccent,
    height: '18px',
    paddingTop: '18px',
  },
  form: {
    margin: 'auto',
    padding: '35px 50px 50px',
  },
  formButton: {
    margin: '10px'
  },
  confimation: {
    margin: '20px'
  },
  email: {
    fontWeight: 'bold'
  },
  check: {
    fontSize: '64px',
    color: 'green'
  }
};

class FirebaseEmailSignin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFirebaseSignin = this.handleFirebaseSignin.bind(this);
  }

  handleChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleFirebaseSignin() {
    this.props.emailSignin(this.state.email);
  }

  render() {
    const { user } = this.props;
    const propErrors = {};
    let errorMsg = '';
    if (user.emailSigninError) {
      // TODO fetch can get better errors
      // eslint-disable-next-line
      errorMsg = get(user.emailSigninError, 'content.message') || get(user.emailSigninError, 'content.error') || user.emailSigninError.message;
    }
    return (
      <div style={styles.container} >
        {!this.props.user.emailSignin ? (
          <Card style={styles.loginBox}>
            <CardHeader title="Sign in with your email" />
            <div style={styles.errorText}>{errorMsg}</div>
            <div style={styles.form}>
              <TextField
                className="login-field"
                label="email"
                name="email"
                fullWidth={true}
                error={!!propErrors.email}
                onChange={this.handleChange}
                value={this.state.email}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.props.router.push('/login')}
                style={styles.formButton}
              >Cancel</Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleFirebaseSignin}
                style={styles.formButton}
                disabled={this.props.user.emailSigninPending || !this.state.email}
              >Sign In</Button>
            </div>
          </Card>
        ) : (
          <Card style={styles.loginBox}>
            <CardHeader title="Sign-in emal sent" />
            <CheckCircleTwoTone style={styles.check}/>
            <div style={styles.confimation}>
             A sign-in email with additional instructions was sent to <span style={styles.email}>{this.state.email}</span>. Check your email to complete sign-in.
            </div>
          </Card>
        )}
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps, { auth, emailSignin })(FirebaseEmailSignin);
